import Vue from "vue";
import VueLodash from "vue-lodash";
import lodash from "lodash";

// name is optional
Vue.use(VueLodash, { lodash });

/* eslint no-unused-vars: "off" */
const _ = require("lodash");
